/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Grid,
  Stack,
  Radio,
  Select,
  Button,
  MenuItem,
  TextField,
  Typography,
  RadioGroup,
  InputLabel,
  FormControl,
  Autocomplete,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormHelperText,
  IconButton
} from '@mui/material';
import _ from 'lodash';
import {
  callEndTime,
  timeZonWiseDateTime,
  createZoomMeetingUrl,
  showCharacterCountWarning
} from '../components/common';
import { MOBILE_SX } from '../../../mobile/mobileApp';
import uuid from 'react-uuid';
import { API } from '../../../api';
import moment from 'moment-timezone';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import MyTooltip from '../components/MyTooltip';
import { useSearchParams } from 'react-router-dom';
import Left from '../../../assets/images/Left.svg';
import { useModule } from '../../../utils/useModule';
import Right from '../../../assets/images/Right.svg';
import { queryKeys } from '../../../queries/queryKeys';
import { getChatUsers } from '../../../routes/helpers';
import { useQueryClient } from '@tanstack/react-query';
import { getUserDetails } from '../../../utils/orgName';
import './../../../assets/style/CallBookingCalendar.css';
import useMyMentors from '../../../queries/useMyMentors';
import { timezones } from '../../profile-page/timeZones';
import { useXpPoints } from '../components/menteeXpPoints';
import { inputCharacterCount } from '../components/common';
import { useMemberWord } from '../../../utils/memberTypeLabels';
import useCallDetails from '../../../queries/useCallDetails';
import useLearningObjs from '../../../queries/useLearningObjs';
// import useProfileDetails from '../../../hooks/useProfileDetails';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
// import { setCallRows } from '../../../redux/slices/call/callsReducer';
import { callsCountActions } from '../../../redux/slices/callCountSlice';
import { setUpdateMeetingFlag } from '../../../redux/slices/updateMeeting';
import CallBookingPopupLoader from '../../../Loader/CallBookingPopupLoader';
import { eventTracking, events, attributeKeys } from '../../../utils/amplitude';

interface CallBookingCalendarProps {
  onClose: () => void; // Function to close the calendar
  channelNaame: string;
  chatType: string;
  threadParticipantsUsers: any[];
  pageName: string;
  bookedCallDetails: any;
  isCallEditing?: boolean;
  title?: any;
  objectiveDetails?: any;
  onMeetingScheduled?: (meetingDetails: any) => void;
  handleCloseRecruitMentor?: () => void;
  /** From Chat: other user id and role from getCommunityGroupsUsersListNew (for mentee-mentor flow and overlapping objectives) */
  otherParticipantId?: string;
  otherParticipantRole?: string;
}

let chatThreadId = '';
let callBookedWith: string | null;
let participantscommunicationId: any[];

const CallBookingCalendar: React.FC<CallBookingCalendarProps> = ({
  title,
  onClose,
  channelNaame,
  threadParticipantsUsers,
  chatType,
  pageName,
  bookedCallDetails,
  isCallEditing = false,
  objectiveDetails,
  onMeetingScheduled,
  handleCloseRecruitMentor,
  otherParticipantId: otherParticipantIdFromChat,
  otherParticipantRole: otherParticipantRoleFromChat
}) => {
  // State variables for selected date and time, invitees, and description
  const page = 1; // Set your desired page size
  const [pageSize, setPageSize] = useState(10);
  const userCallsData = useCallDetails(page, pageSize);
  const [selectedDateTime, setSelectedDateTime] = useState<Date | null>(null);
  const [selectedUtcDate, setSelectedUtcDate] = useState<any | null>(null);
  const [ParticipantUsers, setParticipantUsers] = useState<any[]>([]);
  const [matchingMembersData, setMatchingMembersData] = useState<any[]>([]);
  const [selectedMember, setSelectedMember] = useState<any | null>(null);
  const [selectedCommIds, setselectedCommIds] = useState<any[]>([]);
  const [timeInterval, setTimeInterval] = useState('30');
  const [callTitle, setCallTitle] = useState('');
  const [description, setDescription] = useState<string>('');
  const [privateNotes, setPrivateNotes] = useState<string>('');
  const [originalBookBy, setOriginalBookBy] = useState<string>('');
  const [originalBookWith, setOriginalBookWith] = useState<string>('');
  const [selectedTime, setSelectedTime] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const threadId = searchParams.get('threadid') || '';
  // const { mentee } = useProfileDetails();
  const selectedGroup = useAppSelector((state) => state.selectedGroup.data);
  const trackerUserEmailCal = useAppSelector((state) => state.userProfile.data?.personal_details?.email);
  const groupRoleList = useAppSelector((state) => state.groupRoleList?.data) || [];
  const groupDetails = useAppSelector((state) => state.groupDetails?.data);
  const w = useMemberWord();
  const menteePossessive = w('mentee', { lower: true, possessive: true });
  chatThreadId = threadId || '';
  const [calendarDefaultDate, setcalendarDefaultDate] = useState(new Date());
  const userData = useAppSelector((state) => state.userProfile.data);
  const fetchCommunityMembersData = useAppSelector((state) => state.acsCommunityUsers.data);
  const tokens = localStorage.getItem('tokens') ? JSON.parse(localStorage.getItem('tokens') || '') : {};
  const dispatch = useAppDispatch();
  const currentUsercommunicationId = userData?.personal_details?.communicationId;
  const timzoneCode = userData?.personal_details?.timezone ?? '';
  const currentUserTimeZone = getTimeZoneNameCodeByValue(userData?.personal_details?.timezone || '') ?? '';
  const getXpPoints = useXpPoints();
  const [showInviteeList, setShowInviteeList] = useState<boolean>(false);
  const selectedGroupIdFromRedux = selectedGroup?.id || '';
  const selectedGroupIdFromRoleList = useMemo(() => {
    const list = Array.isArray(groupRoleList) ? groupRoleList : [];
    const entry = list.find((e: any) => {
      const r = (e?.role || e?.displayRole || '').toLowerCase();
      return r === 'mentee' || r === 'mentor';
    });
    return entry?.id || '';
  }, [groupRoleList]);
  const selectedGroupId = selectedGroupIdFromRedux || selectedGroupIdFromRoleList || '';
  const { orgId } = getUserDetails();
  const updateMeeting = useAppSelector((state) => state.updateMeeting);
  const queryClient = useQueryClient();

  const {
    data: mentorsData,
    isLoading: mentorLoading,
    refetch: mentorsRefetch
  } = useMyMentors({
    grpId: selectedGroupId,
    orgId,
    location: getUserDetails().location
  });

  const {
    data: objectives,
    isLoading: objLoading,
    refetch: fetchObjectives,
    isError: objError
  } = useLearningObjs({ orgId, grpId: selectedGroupId });

  const googleMeetingAuto = 'googleMeetingAuto';
  const virtualMeeting = 'virtualMeeting';
  const inPersonEvent = 'inPersonEvent';
  const [learningObjectives, setLearningObjectives] = useState<{ id: string; objective: string }[]>([]);
  const [selectedObjective, setSelectedObjective] = useState<{ id: string; objective: string } | null>(null);
  const { isMentorship } = useModule();
  const [objTitle, setObjTitle] = useState(title);

  /* * */
  useEffect(() => {
    if (!title) return;
    const foundObjective =
      typeof title === 'object' ? title : learningObjectives.find((obj) => obj.objective === title);
    setSelectedObjective(foundObjective || null);
  }, [title, learningObjectives]);

  useEffect(() => {
    if (!bookedCallDetails) {
      setSelectedDateTime(new Date());

      if (chatType === 'Groups') {
        setOriginalBookBy('');
        setOriginalBookWith('');
        setMatchingMembersData([]);
        setParticipantUsers([]);
      } else {
        const matchingMembers = Array.isArray(threadParticipantsUsers)
          ? threadParticipantsUsers.filter((member) => member?.id?.communicationUserId !== currentUsercommunicationId)
          : [];
        let communicationUserIds: any = [];

        if (pageName === 'Chat') {
          communicationUserIds = matchingMembers.map((user) => user?.id?.communicationUserId);
        } else if (pageName === 'Community') {
          communicationUserIds = matchingMembers.map((user) => user?.personal_details?.communicationId);
        } else if (['Mentee', 'Mentor'].includes(pageName)) {
          communicationUserIds = matchingMembers.map((user) => user?.communicationId);
        } else {
          communicationUserIds = matchingMembers.map((user) => user?.id?.communicationId);
        }

        setselectedCommIds(communicationUserIds[0]);
        const matchingMembersRow = fetchCommunityMembersData?.filter((member) =>
          communicationUserIds?.includes(member?.id?.communicationUserId)
        );

        if (matchingMembersRow.length > 0) {
          setOriginalBookBy(userData?.personal_details?.name);
          setOriginalBookWith(matchingMembersRow[0]?.displayName);
        }
        setParticipantUsers(communicationUserIds);
      }
    } else {
      if (bookedCallDetails?.meetingType === 'Dosen') {
        // Legacy Dosen virtual meetings: the option was removed from the picker,
        // so editing one moves it to the auto-generated Google Meet.
        setVirtualLink('');
        setMeetingType(googleMeetingAuto);
      } else if (bookedCallDetails?.meetingType === 'InPerson') {
        setVirtualLink('');
        setMeetingType(inPersonEvent);
      } else if (bookedCallDetails?.meetingType === 'Gmeet' && !bookedCallDetails?.meetingLink) {
        // Auto-generated Google Meet whose link the BE hasn't filled in yet.
        // Without this branch it fell through to `virtualMeeting` with an empty
        // link and, on save, the type silently reverted to 'Dosen'.
        // TODO(BE flag): once the meeting record exposes an "auto-generated"
        // marker, route already-filled auto Gmeet links here too instead of
        // showing them as a 3rd-party link.
        setVirtualLink('');
        setMeetingType(googleMeetingAuto);
      } else {
        setVirtualLink(bookedCallDetails?.meetingLink || '');
        setMeetingType(virtualMeeting);
      }

      let filteredMidValues = [bookedCallDetails?.callBookedBy?.id];

      if (bookedCallDetails?.chatType === 'Chats') {
        filteredMidValues.push(bookedCallDetails?.callBookedWith?.id);
        setOriginalBookBy(bookedCallDetails?.callBookedBy?.displayName);
        setOriginalBookWith(bookedCallDetails?.callBookedWith?.displayName);

        const bookwithmembers = bookedCallDetails?.participantsUser.filter(
          (item: { mid: any }) => item.mid === bookedCallDetails?.callBookedWith?.id
        );

        const bookwithmembersComId = bookwithmembers.map((member: { communicationId: any }) => member.communicationId);
        setselectedCommIds(bookwithmembersComId);
      }

      const matchingMembers = bookedCallDetails?.participantsUser.filter(
        (item: { mid: any }) => !filteredMidValues.includes(item.mid)
      );

      const newCommunicationUserIds = matchingMembers.map((member: { communicationId: any }) => member.communicationId);
      const matchingMembersRow = fetchCommunityMembersData.filter((member) =>
        newCommunicationUserIds.includes(member.id.communicationUserId)
      );

      setMatchingMembersData(matchingMembersRow);
      setParticipantUsers(newCommunicationUserIds);
    }
  }, [
    bookedCallDetails,
    chatType,
    currentUsercommunicationId,
    fetchCommunityMembersData,
    pageName,
    threadParticipantsUsers,
    userData?.personal_details?.name
  ]);

  const loginUser = useAppSelector((state) => state.userProfile.data);
  const admins = _.get(loginUser, 'admins');
  const desiredCommunityMembers = useMemo(() => {
    const loginUserRole = localStorage.getItem('role');
    return getChatUsers(fetchCommunityMembersData, loginUserRole, matchingMembersData, admins);
  }, [admins, fetchCommunityMembersData, matchingMembersData]);

  /** Handle selected date and time change */
  const handleDateTimeChange = (date: Date | null) => {
    setSelectedTime('');
    setSelectedDateTime(date);
  };

  /**
   * Default call date selected
   */
  useEffect(() => {
    if (bookedCallDetails?.callDate) {
      const dateFormate = timeZonWiseDateTime(
        bookedCallDetails?.callDate?.toString(),
        bookedCallDetails?.callTime?.toString(),
        timzoneCode
      );
      const callDate = new Date(dateFormate);
      setSelectedDateTime(callDate);
      const utcDate = callDate.toISOString().split('T')[0]; // Extracts the date part
      setSelectedUtcDate(utcDate);
    }
    if (bookedCallDetails?.callTime) {
      setSelectedTime(bookedCallDetails?.callTime);
    }
    setDescription(bookedCallDetails?.description || '');
    if (bookedCallDetails) {
      setTimeInterval(bookedCallDetails?.callTimeInterval);
    }
    setCallTitle(bookedCallDetails?.callTitle || '');
  }, [bookedCallDetails]);

  /** Handle selected call length */
  const handleCallLength = (event: any) => {
    setTimeInterval(event.target.value);
  };

  /** Handle call title length */
  const handleCallTitle = (event: any) => {
    setCallTitle(event.target.value);
    showCharacterCountWarning(event.target.value, maxCharacterCountCallTitle);
  };

  /** Making selected ing for Print Top of the calendar and time slots */
  const formatMonthYear = (date: Date | null) => {
    const currentDate = new Date();
    const displayDate = date || currentDate;

    const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric', weekday: 'long' };
    const monthYearWithWeekday = displayDate.toLocaleDateString(undefined, options);

    const [month, year, day] = monthYearWithWeekday.split(' ');
    const monthYear = `${month} ${year}`; //'September 2023'
    // const monthYearDay = `${month} ${year}, ${day}`; // 'September 2023, Thursday'
    const dayDate = `${day}, ${displayDate.getDate()}`; // 'Thursday, 21'
    return { monthYear, dayDate };
  };

  /** handle time slot change */
  const handleTimeSlotChange = (utcDateTimeString: string) => {
    if (utcDateTimeString) {
      const utcDateTime = new Date(utcDateTimeString);
      // Extract date and time components into different variables
      const utcDate = utcDateTime.toISOString().split('T')[0]; // Extracts the date part
      const utcTime = utcDateTime.toISOString().split('T')[1].split('.')[0].slice(0, 5); // Extract HH:mm
      setSelectedUtcDate(utcDate);
      setSelectedTime(utcTime);
    }
  };

  /** Handle selected invitees change */
  const handleInviteesChange = (event: React.ChangeEvent<{}>, value: any[]) => {
    setMatchingMembersData(value);
    let newParticipantUsers: any = [];
    newParticipantUsers = value?.map((user) => user?.id?.communicationUserId);
    setParticipantUsers(newParticipantUsers);
  };

  useEffect(() => {
    if (!bookedCallDetails) {
      setShowInviteeList(pageName !== 'Calendar' || !!selectedMember);
      setMatchingMembersData([]);
      setParticipantUsers([]);
    } else {
      setShowInviteeList(true);
    }
  }, [selectedMember, pageName]);

  /** Handle purpose of call change */
  const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    showCharacterCountWarning(newValue, maxCharacterCount);
    setDescription(newValue);
  };

  /** Handle PrivateNotes change */
  const handlePrivateNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    showCharacterCountWarning(newValue, maxCharacterCount);
    setPrivateNotes(newValue);
  };

  /** Field Character Count */
  const maxCharacterCount = 1500;
  const maxCharacterCountCallTitle = 100;
  const totalCharactersPrivateNotes = inputCharacterCount(description, maxCharacterCount);
  const totalCharactersDescription = inputCharacterCount(description, maxCharacterCount);
  const totalCharactersCallTitle = inputCharacterCount(callTitle, maxCharacterCountCallTitle);

  const validateLink = (url: string) => {
    const zoomRegex = /^https:\/\/(?:[\w-]+\.)*zoom\.us\/(?:j\/)?\d{9,11}|u\/[a-zA-Z0-9]+$/i;
    const teamsRegex = /^https:\/\/teams\.live\.com\/meet\/\d+(\?p=.+)?/i;
    const googleMeetRegex = /^https:\/\/meet\.google\.com\/[a-z0-9\-]+$/i;

    // Check if the URL matches any of the regex patterns
    if (zoomRegex.test(url) || teamsRegex.test(url) || googleMeetRegex.test(url)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  /** Handle the Confirm button click */
  const handleConfirm = () => {
    const participantUsersData = [...ParticipantUsers];
    if (bookedCallDetails) {
      let filteredMidValues: any[] = [];
      if (bookedCallDetails?.chatType === 'Chats') {
        filteredMidValues = [bookedCallDetails?.callBookedBy?.id, bookedCallDetails?.callBookedWith?.id];
      } else {
        filteredMidValues = [bookedCallDetails?.callBookedBy?.id];
      }
      const matchingMembers = bookedCallDetails?.participantsUser.filter((item: { mid: any }) =>
        filteredMidValues.includes(item.mid)
      );
      matchingMembers.forEach((member: { communicationId: any }) => {
        if (!participantUsersData.includes(member.communicationId)) {
          participantUsersData.push(member.communicationId);
        }
      });
    } else {
      const loginUserCommnicationId = currentUsercommunicationId;
      if (!participantUsersData.includes(loginUserCommnicationId)) {
        participantUsersData.push(loginUserCommnicationId);
      }
      if (pageName === 'Calendar') {
        participantUsersData.push(selectedMember?.id?.communicationId);
      }
      if (chatType === 'Groups') {
        const participantUsersComIds = threadParticipantsUsers.map((userRow) => userRow.id.communicationUserId);
        participantUsersComIds.forEach((member) => {
          if (!participantUsersData.includes(member)) {
            participantUsersData.push(member);
          }
        });
      }
    }

    if (callTitle.trim().length === 0) {
      toast.error('Please enter the title of meeting');
      return;
    }

    // Validate if Attendee is Selected
    if (pageName === 'Calendar' && !selectedMember) {
      toast.error('Please select an attendee');
      return;
    }

    // Validate if a date, time, and time slot are selected
    if (!selectedDateTime || !selectedTime) {
      toast.error('Please select a date and time');
      return;
    }

    if (meetingType === virtualMeeting && (!virtualLink || !isValid)) {
      setIsValid(false);
      return;
    }

    const formattedDate = selectedUtcDate;

    // Make an API request using Axios
    const { orgId } = getUserDetails();
    const currentUserId = getUserDetails().userId;

    /**
     * Data for call booking api
     */
    let meetingId = uuid();
    let callFlag = 'insert';
    if (bookedCallDetails) {
      meetingId = bookedCallDetails?.meetingId;
      callFlag = 'edit';
    }

    const timeIntervalNumber = parseInt(timeInterval, 10);
    const meetingLink = createZoomMeetingUrl(meetingId, formattedDate, selectedTime, timeIntervalNumber, '');
    const CallEndTime = callEndTime(formattedDate, selectedTime, timeIntervalNumber);
    let type = 'Dosen';
    if (meetingType === inPersonEvent) {
      type = 'InPerson';
    } else if (meetingType === googleMeetingAuto) {
      // Auto-generated Google Meet — BE creates the space + Calendar invite when
      // meetingType='Gmeet' and meetingLink is empty.
      type = 'Gmeet';
    } else if (virtualLink.includes('zoom')) {
      type = 'Zoom';
    } else if (virtualLink.includes('meet.google.com')) {
      type = 'Gmeet';
    } else if (virtualLink.includes('teams.live.com')) {
      type = 'Teams';
    }
    const requestBody: {
      meetingId: any;
      callDate: string;
      callTime: string;
      callFlag: string;
      callEndTime: number;
      callBookedWith?: string | null;
      callBookedBy: string | null | undefined;
      callTimeInterval: number;
      participantsUser: any[];
      chatThreadId?: string;
      chatType?: string;
      description?: string;
      meetingLink: string;
      callTitle?: string;
      meetingType: string;
      objective?: string;
    } = {
      meetingId: meetingId,
      callDate: formattedDate,
      callTime: selectedTime,
      callFlag: callFlag,
      callEndTime: CallEndTime,
      callBookedBy: currentUsercommunicationId,
      callTimeInterval: timeIntervalNumber,
      participantsUser: participantUsersData,
      meetingLink:
        meetingType === virtualMeeting
          ? virtualLink.trim()
          : meetingType === inPersonEvent
          ? ''
          : meetingType === googleMeetingAuto
          ? ''
          : meetingLink,
      meetingType: type,
      ...(isMenteeMentorFlow && selectedObjective?.id ? { objective: selectedObjective.id } : {})
    };

    if (chatThreadId) {
      requestBody.chatThreadId = chatThreadId;
    }
    if (callTitle) {
      requestBody.callTitle = callTitle;
    }
    if (chatType) {
      requestBody.chatType = chatType;
    }

    if (chatType) {
      let bookwithUser: any = '';
      if (bookedCallDetails) {
        if (bookedCallDetails?.chatType === 'Groups') {
          const chatThreadId = bookedCallDetails?.chatThreadId;
          bookwithUser = chatThreadId;
        } else {
          const cllBookwithUserId = bookedCallDetails?.callBookedWith?.id;
          const matchedParticipant = bookedCallDetails?.participantsUser.find(
            (participant: { mid: any }) => participant?.mid === cllBookwithUserId
          );
          bookwithUser = matchedParticipant?.communicationId;
        }
      } else {
        if (pageName === 'Calendar') {
          bookwithUser = selectedMember?.id?.communicationId;
        } else {
          if (chatType === 'Groups') {
            bookwithUser = chatThreadId;
          } else {
            const matchingMembers = Array.isArray(threadParticipantsUsers)
              ? threadParticipantsUsers.filter(
                  (member) => member?.id?.communicationUserId !== currentUsercommunicationId
                )
              : [];
            let communicationUserIds: any = '';
            if (pageName === 'Chat') {
              communicationUserIds = matchingMembers?.map((user) => user?.id?.communicationUserId);
            } else if (pageName === 'Community') {
              communicationUserIds = matchingMembers?.map((user) => user?.personal_details?.communicationId);
            } else if (['Mentee', 'Mentor'].includes(pageName)) {
              communicationUserIds = matchingMembers?.map((user) => user?.communicationId);
            } else {
              communicationUserIds = matchingMembers?.map(
                (user: { id: { communicationId: any } }) => user?.id?.communicationId
              );
            }
            if (communicationUserIds.length > 0) {
              bookwithUser = communicationUserIds[0];
            }
            if (!participantUsersData.includes(bookwithUser)) {
              participantUsersData.push(bookwithUser);
            }
          }
        }
      }
      callBookedWith = bookwithUser;
    }
    if (callBookedWith) {
      requestBody.callBookedWith = callBookedWith;
    }
    if (description) {
      requestBody.description = description;
    }
    setLoading(true);
    /**
     * Call the api
     */
    bookedTheCall(requestBody, orgId, getUserDetails().location, currentUserId);
  };

  const callsCount = useAppSelector((state) => state.callsCount.callsCount);

  /** Booked the call */
  const bookedTheCall = async (
    callData: {
      meetingId: any;
      callDate: string;
      callTime: string;
      callFlag: string;
      callEndTime: number;
      callBookedWith?: string | null | undefined;
      callBookedBy: string | null | undefined;
      callTimeInterval: number;
      participantsUser: any[];
      chatThreadId?: string | undefined;
      chatType?: string | undefined;
      description?: string | undefined;
      callTitle?: string;
      meetingLink: string;
      meetingType: string;
    },
    orgId: string,
    location: string,
    currentUserId: string
  ) => {
    try {
      const response = await API.createCall(callData, orgId, location, currentUserId);
      if (response.status === 200) {
        const ud = getUserDetails();
        eventTracking(events.meetingScheduled, {
          [attributeKeys.programName]: selectedGroup?.name || '',
          [attributeKeys.userRole]: selectedGroup?.role || '',
          [attributeKeys.organizationName]: ud.orgName || '',
          [attributeKeys.userEmail]: trackerUserEmailCal || '',
          [attributeKeys.meetingType]: callData.meetingType || '',
          meetingId: callData.meetingId
        });
        // refetch .....
        await userCallsData
          .invalidateQuery()
          .then((res) => {})
          .catch((err) => {})
          .finally(() => {
            userCallsData.refetch();
          });
        if (!isCallEditing) {
          dispatch(callsCountActions.updateCount(callsCount + 1));
        }
        if (onMeetingScheduled) {
          onMeetingScheduled({
            ...callData,
            response: response.data
          });
        }
        setLoading(false);
        onClose();
        setSelectedDateTime(null);
        setOriginalBookBy('');
        setOriginalBookWith('');
        setMatchingMembersData([]);
        setParticipantUsers([]);
        setDescription('');
        // dispatch(setCallRows(_.get(response, 'data.getScheduleCallResponse', [])));
        const isRefetch = localStorage.getItem('isRefetchMentors');
        if (isRefetch) {
          mentorsRefetch();
          fetchObjectives();
          queryClient.fetchQuery({
            queryKey: [queryKeys.GET_UPCOMING_MEETING, orgId]
          });
          dispatch(setUpdateMeetingFlag(!updateMeeting));
          localStorage.removeItem('isRefetchMentors');
        }
        toast.success('Meeting booked successfully');
        if (handleCloseRecruitMentor) {
          handleCloseRecruitMentor();
        }
        if (selectedGroup?.role === 'mentee') {
          getXpPoints('mentee');
        }
      }
    } catch (e: any) {
      setLoading(false);
      const beMessage = e?.response?.data?.message;
      const gmeetGenFailed =
        meetingType === googleMeetingAuto &&
        (e?.response?.status === 500 || /google meet|meeting link/i.test(beMessage || ''));
      if (gmeetGenFailed) {
        // BE couldn't auto-generate the Google Meet link. Keep the modal (and the
        // rest of the form) open and switch to the manual link option so the user
        // can paste one and resubmit — instead of losing everything.
        setMeetingType(virtualMeeting);
        toast.error(beMessage || 'The Google Meet link could not be made. Paste a meeting link and try again.');
        return;
      }
      onClose();
      setSelectedDateTime(null);
      setOriginalBookBy('');
      setOriginalBookWith('');
      setMatchingMembersData([]);
      setParticipantUsers([]);
      setDescription('');
      toast.error('The meeting could not be booked. Try again.');
    }
  };

  /** Handle cancel */
  const handleCancel = () => {
    setSelectedDateTime(null);
    setOriginalBookBy('');
    setOriginalBookWith('');
    setMatchingMembersData([]);
    setParticipantUsers([]);
    setDescription('');
    onClose();
  };

  /** Handle month change */
  const handleMonthChange = (action: 'prev' | 'next') => {
    setSelectedDateTime((prevDate) => {
      const currentDate = new Date();
      const newDate = prevDate ? new Date(prevDate) : new Date();

      if (action === 'prev') {
        newDate.setMonth(newDate.getMonth() - 1);
      } else if (action === 'next') {
        // Check if the current date is within the 1st to 31st range
        if (newDate.getDate() >= 1 && newDate.getDate() <= 31) {
          // Always transition to the 1st day of the next month
          newDate.setDate(1);
          newDate.setMonth(newDate.getMonth() + 1);
        } else {
          // Check if newDate is the last day of the month
          const lastDayOfMonth = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0).getDate();

          if (newDate.getDate() === lastDayOfMonth) {
            // If it's the last day, set to the 1st day of the next month
            newDate.setDate(1);
            newDate.setMonth(newDate.getMonth() + 1);
          } else {
            // Otherwise, simply increment the month
            newDate.setMonth(newDate.getMonth() + 1);
          }
        }
      }
      if (meetingType === inPersonEvent) return newDate;
      return newDate < currentDate ? currentDate : newDate;
    });
  };

  function customStartCase(input: string) {
    const words = input.split(' ');
    const result = words.map((word: any) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return result.join(' ');
  }

  /** Get timeZoneNameCode */
  function getTimeZoneNameCodeByValue(value: string): string | undefined {
    const timezone = timezones.find((zone) => zone.value === value);
    return timezone ? timezone.timeZoneNameCode : '';
  }

  /** Get time slots */
  const getTimeSlots = () => {
    if (timeInterval) {
      if (selectedDateTime) {
        const timezone = currentUserTimeZone || '';
        const selectedDate = moment.tz(selectedDateTime, timezone).startOf('day');
        const endTime = moment(selectedDate).endOf('day');
        // added 30 here for fixed 30 minutes interval
        const timeIntervals = 30;

        const timeSlots = [];
        let currentTimeSlot = selectedDate.clone().startOf('hour');

        while (currentTimeSlot.isSameOrBefore(endTime)) {
          if (meetingType === inPersonEvent || currentTimeSlot.isAfter(moment().tz(timezone))) {
            const currentTimeZoneSlot = currentTimeSlot.format('h:mm a');
            const utcTimeZoneSlot = moment.tz(currentTimeSlot, 'UTC').format('HH:mm');

            const currentTimezoneAbbreviation = moment.tz(timezone).format('z');
            const timeSlotWithTimeZone = `${currentTimeZoneSlot} (${currentTimezoneAbbreviation})`;

            const timeZoneWiseTimeSlot = {
              currentTimeZoneSlot: timeSlotWithTimeZone,
              utcTimeZoneSlot: utcTimeZoneSlot,
              utcDateTime: currentTimeSlot.toISOString() // Add UTC DateTime
            };

            timeSlots.push(timeZoneWiseTimeSlot);
          }
          currentTimeSlot = currentTimeSlot.add(timeIntervals, 'minutes');
        }

        return (
          <>
            {timeSlots?.map((timeSlot) => (
              <div key={timeSlot.currentTimeZoneSlot}>
                <input
                  type="radio"
                  name="timeSlot"
                  value={timeSlot.utcTimeZoneSlot}
                  checked={selectedTime === timeSlot.utcTimeZoneSlot}
                  onChange={() => handleTimeSlotChange(timeSlot.utcDateTime)} // Pass UTC DateTime
                  className="slotsCheckBtn"
                  id={timeSlot.utcTimeZoneSlot}
                />
                <label
                  htmlFor={timeSlot.utcTimeZoneSlot}
                  className={`checkedBoxs ${selectedTime === timeSlot.utcTimeZoneSlot ? 'Active' : ''}`}
                >
                  {timeSlot.currentTimeZoneSlot}
                </label>
              </div>
            ))}
          </>
        );
      }
    }
    return null;
  };

  /** Meeting Type  */
  // Dosen virtual meetings were retired as a booking option (July 2026) — new
  // bookings default to the auto-generated Google Meet.
  const [meetingType, setMeetingType] = useState(googleMeetingAuto);
  const [virtualLink, setVirtualLink] = useState('');

  const handleMeetingTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMeetingType(event.target.value);
  };

  const [isValid, setIsValid] = useState(true);

  const handleMeetingLinkChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVirtualLink(event.target.value);
    validateLink(event.target.value.trim());
  };

  const fetchUserLearningObjectives = async (orgId: string) => {
    try {
      const response = await API.UserLearningObjectives({ orgId });
      return Array.isArray(response.data?.data) ? response.data?.data : [];
    } catch (error) {
      return [];
    }
  };

  const roleFromSelectedGroup = selectedGroup?.role?.toLowerCase?.() || '';
  const roleFromGroupList = useMemo(() => {
    const list = Array.isArray(groupRoleList) ? groupRoleList : [];
    const entry = list.find((e: any) => {
      const r = (e?.role || e?.displayRole || '').toLowerCase();
      return r === 'mentee' || r === 'mentor';
    });
    return entry ? (entry.role || entry.displayRole || '').toLowerCase() : '';
  }, [groupRoleList]);
  const currentUserRole = roleFromSelectedGroup || roleFromGroupList || '';

  const isMentorshipFromGroupDetails = groupDetails?.model === 'mentorship';
  const isMentorshipResolved =
    isMentorship ||
    isMentorshipFromGroupDetails ||
    (pageName === 'Chat' && (currentUserRole === 'mentee' || currentUserRole === 'mentor'));

  const otherRoleForFlow = (otherParticipantRoleFromChat || '').toLowerCase();
  const isMenteeMentorFromChat =
    pageName === 'Chat' &&
    otherParticipantRoleFromChat &&
    ((currentUserRole === 'mentee' && otherRoleForFlow === 'mentor') ||
      (currentUserRole === 'mentor' && otherRoleForFlow === 'mentee'));

  const isSameRole = currentUserRole && otherRoleForFlow && currentUserRole === otherRoleForFlow;
  const isMenteeMentorFlow =
    isMenteeMentorFromChat ||
    (!isSameRole &&
      isMentorshipResolved &&
      (currentUserRole === 'mentee' || currentUserRole === 'mentor') &&
      (pageName === 'Mentee' || pageName === 'Mentor' || pageName === 'Chat' || pageName === 'Community'));
  const currentUserIsMentee = currentUserRole === 'mentee';
  const currentUserIsMentor = currentUserRole === 'mentor';

  const otherParticipant = useMemo(() => {
    if (pageName === 'Calendar' && selectedMember) return selectedMember;
    const arr = Array.isArray(threadParticipantsUsers) ? threadParticipantsUsers : [];
    const other = arr.find(
      (m: any) =>
        m?.id?.communicationUserId !== currentUsercommunicationId ||
        m?.communicationId !== currentUsercommunicationId ||
        m?.personal_details?.communicationId !== currentUsercommunicationId
    );
    return other || arr[0] || null;
  }, [pageName, selectedMember, threadParticipantsUsers, currentUsercommunicationId]);

  const otherParticipantIdRaw = otherParticipant?.id;
  const otherParticipantUserIdFromThread =
    otherParticipant?._id ||
    otherParticipant?.userId ||
    otherParticipant?.user_id ||
    (typeof otherParticipantIdRaw === 'string' ? otherParticipantIdRaw : null) ||
    otherParticipant?.mentorUserId ||
    otherParticipant?.menteeId ||
    otherParticipant?.mid ||
    (typeof otherParticipantIdRaw === 'object' && otherParticipantIdRaw != null ? (otherParticipantIdRaw as any).userId : null) ||
    '';
  const otherParticipantUserId =
    pageName === 'Chat' && otherParticipantIdFromChat ? otherParticipantIdFromChat : otherParticipantUserIdFromThread;

  const [otherParticipantObjectives, setOtherParticipantObjectives] = useState<{ id: string; objective: string }[]>([]);

  useEffect(() => {
    if (!isMenteeMentorFlow || !otherParticipantUserId || !selectedGroupId || !orgId) {
      setOtherParticipantObjectives([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const res = await API.adminViewObjectives({ orgId, grpId: selectedGroupId, userId: otherParticipantUserId });
        const raw = res?.data?.data;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.learningObjectives)
            ? raw.learningObjectives
            : raw?.learningObjectives?.objectives || [];
        const normalized = (list || []).map((o: any) => ({
          id: o?.id ?? o?._id ?? o?.objectiveId ?? '',
          objective: o?.objective ?? o?.name ?? o?.content ?? ''
        })).filter((o: { id: string }) => o.id);
        if (!cancelled) setOtherParticipantObjectives(normalized);
      } catch {
        if (!cancelled) setOtherParticipantObjectives([]);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [isMenteeMentorFlow, otherParticipantUserId, selectedGroupId, orgId]);

  const overlappingObjectives = useMemo(() => {
    if (!isMenteeMentorFlow) return learningObjectives;
    const otherIds = new Set(otherParticipantObjectives.map((o) => String(o.id)));
    if (otherIds.size === 0) return learningObjectives;
    return learningObjectives.filter((obj) => otherIds.has(String(obj.id)));
  }, [isMenteeMentorFlow, learningObjectives, otherParticipantObjectives]);

  useEffect(() => {
    const loadLearningObjectives = async () => {
      const data = await fetchUserLearningObjectives(orgId);
      setLearningObjectives(data);
      if (isCallEditing && bookedCallDetails?.objective) {
        const matchedObjective = data.find((obj: any) => obj.id === bookedCallDetails.objective);
        if (matchedObjective) {
          setSelectedObjective(matchedObjective);
        }
      } else if (isCallEditing && objectiveDetails) {
        setSelectedObjective(objectiveDetails);
      }
    };
    loadLearningObjectives();
  }, [orgId]);

  return (
    <Box display="flex" flexDirection="column" height="100%" width="100%" minWidth={0}>
      <DialogContent
        sx={{
          p: 0,
          bgcolor: '#0F0F0F',
          borderRadius: '8px',
          overflow: 'hidden',
          flex: 1,
          // Phone: the full-screen sheet scrolls as a whole, so nothing is clipped here.
          [MOBILE_SX]: { overflow: 'visible', flex: '1 0 auto' }
        }}
      >
        {loading ? (
          <CallBookingPopupLoader />
        ) : (
          <Box className="CallBookingCalendarGrid">
            {/* COLUNA ESQUERDA – FORMULÁRIO */}
            <Box className="CallBookingCalendarCol">
              <Stack gap={1}>
                {/* Meeting agenda / intro */}
                <Box>
                  <Typography
                    sx={{
                      color: '#FDFDFD',
                      fontSize: 16,
                      fontWeight: 700,
                      mb: 0.5
                    }}
                  >
                    Meeting agenda or details
                  </Typography>
                  <Typography
                    sx={{
                      color: '#B6B6B6',
                      fontSize: 14,
                      fontStyle: 'italic'
                    }}
                  >
                    Make sure you have agreed a time before booking a meeting.
                  </Typography>
                </Box>

                {/* Title of Meeting */}
                <Box>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <InputLabel sx={labelStyle}>Title of Meeting *</InputLabel>
                    <Typography sx={{ color: '#868686', fontSize: 12 }}>
                      {`${totalCharactersCallTitle?.textValueLength}/${totalCharactersCallTitle?.maxCharacterCount}`}
                    </Typography>
                  </Stack>
                  <TextField
                    id="callTitle"
                    value={callTitle}
                    InputProps={{
                      inputProps: {
                        maxLength: totalCharactersCallTitle?.maxCharacterCount
                      }
                    }}
                    onChange={handleCallTitle}
                    name="callTitle"
                    placeholder="Title of meeting"
                    fullWidth
                    // sx={inputStyle}
                  />
                </Box>

                {/* Learning Objectives – only in mentee–mentor flows; show overlapping objectives only */}
                {isMenteeMentorFlow && (
                  <Box>
                    <InputLabel sx={labelStyle}>
                      {currentUserIsMentee
                        ? 'Select the learning objectives you will discuss.'
                        : `Select which of this ${menteePossessive} objectives you would like to help them with.`}
                    </InputLabel>
                    <Autocomplete
                      options={overlappingObjectives.filter(
                        (obj, index, self) => index === self.findIndex((o) => o.objective === obj.objective)
                      )}
                      getOptionLabel={(option) => option.objective}
                      value={selectedObjective || objTitle || objectiveDetails?.objective}
                      onChange={(event, newValue) => setSelectedObjective(newValue)}
                      renderInput={(params) => <TextField {...params} placeholder="Please Select" />}
                      fullWidth
                      disabled={!!objTitle || !!objectiveDetails?.objective}
                    />
                  </Box>
                )}

                {/* Attendees – Calendar page */}
                {pageName === 'Calendar' && (
                  <Box>
                    <InputLabel sx={labelStyle}>Attendees *</InputLabel>
                    <Autocomplete
                      autoHighlight
                      id="addOtherUser"
                      data-testid="calendar-attendee-select"
                      options={desiredCommunityMembers}
                      getOptionLabel={(option) => (option ? option.displayName : '')}
                      value={selectedMember}
                      isOptionEqualToValue={(option, value) =>
                        _.get(option, 'id.communicationUserId') === _.get(value, 'id.communicationUserId')
                      }
                      renderOption={(props, option) => {
                        if (option && !ParticipantUsers?.includes(option?.id?.communicationId)) {
                          return (
                            <li {...props} key={_.get(option, 'id.communicationUserId', '')}>
                              {customStartCase(_.get(option, 'displayName'))}
                            </li>
                          );
                        }
                        return null;
                      }}
                      renderInput={(params) => <TextField {...params} placeholder="Please Select" sx={inputStyle} />}
                      onChange={(event, newValue) => {
                        setSelectedMember(newValue);
                      }}
                    />
                  </Box>
                )}

                {/* Attendees – Chats (texto combinando BookBy & BookWith) */}
                {chatType === 'Chats' && originalBookBy && originalBookWith && (
                  <Box>
                    <InputLabel sx={labelStyle}>Attendees</InputLabel>
                    <TextField value={`${originalBookBy} & ${originalBookWith}`} disabled fullWidth sx={inputStyle} />
                  </Box>
                )}

                {/* Other Invitees */}
                {showInviteeList && (
                  <Box>
                    <InputLabel sx={labelStyle}>Other Invitees</InputLabel>
                    <Autocomplete
                      multiple
                      id="addOtherUsers"
                      options={desiredCommunityMembers}
                      getOptionLabel={(option) => (option ? option.displayName : '')}
                      value={matchingMembersData}
                      isOptionEqualToValue={(option, value) =>
                        _.get(option, 'id.communicationUserId') === _.get(value, 'id.communicationUserId')
                      }
                      renderOption={(props, option) => {
                        if (pageName === 'Calendar') {
                          if (option && !selectedMember?.id?.communicationId?.includes(option?.id?.communicationId)) {
                            return (
                              <li {...props} key={_.get(option, 'id.communicationUserId', '')}>
                                {customStartCase(_.get(option, 'displayName'))}
                              </li>
                            );
                          }
                        } else if (option && !selectedCommIds?.includes(option?.id?.communicationId)) {
                          return (
                            <li {...props} key={_.get(option, 'id.communicationUserId', '')}>
                              {customStartCase(_.get(option, 'displayName'))}
                            </li>
                          );
                        }
                        return null;
                      }}
                      renderInput={(params) => <TextField {...params} placeholder="Please Select" sx={inputStyle} />}
                      onChange={handleInviteesChange}
                    />
                  </Box>
                )}

                {/* Meeting Duration */}
                <Box>
                  <InputLabel sx={labelStyle}>Meeting Duration *</InputLabel>
                  <Select
                    name="callLength"
                    required
                    value={timeInterval}
                    id="callLength"
                    onChange={handleCallLength}
                    displayEmpty
                    fullWidth
                    sx={inputStyle}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="30">30 mins</MenuItem>
                    <MenuItem value="45">45 mins</MenuItem>
                    <MenuItem value="60">1 hour</MenuItem>
                    <MenuItem value="90">90 mins</MenuItem>
                    <MenuItem value="120">2 hours</MenuItem>
                    <MenuItem value="180">3 hours</MenuItem>
                  </Select>
                </Box>

                {/* Purpose of meeting */}
                <Box>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <InputLabel sx={labelStyle}>Purpose of Meeting</InputLabel>
                    <Typography sx={{ color: '#868686', fontSize: 12 }}>
                      {`${totalCharactersDescription?.textValueLength}/${totalCharactersDescription?.maxCharacterCount}`}
                    </Typography>
                  </Stack>
                  <TextField
                    multiline
                    minRows={3}
                    InputProps={{
                      inputProps: {
                        maxLength: totalCharactersDescription?.maxCharacterCount
                      }
                    }}
                    onChange={handleDescriptionChange}
                    value={description}
                    id="description"
                    data-testid="call-booking-description"
                    name="description"
                    placeholder="What do you want to discuss in the meeting?"
                    fullWidth
                    // sx={textareaStyle}
                  />
                </Box>

                {/* Meeting Host */}
                <Box gap={1}>
                  <InputLabel sx={labelStyle}>Meeting Options</InputLabel>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="meetingHostLabel"
                      id="meetingTypeRadioGroup"
                      name="meetingTypeRadioGroup"
                      value={meetingType}
                      onChange={handleMeetingTypeChange}
                    >
                      <Stack spacing={0}>
                        {/* Google Meet (auto-generated) */}
                        <Box display="flex" alignItems="center" gap={1}>
                          <FormControlLabel
                            value={googleMeetingAuto}
                            control={<Radio sx={radioStyle} />}
                            label=""
                            className="mr-0"
                          />
                          <Typography sx={radioLabel}>
                            Dosen video call (using Google Meet)
                            <MyTooltip
                              gapleft={0.5}
                              iconColor="white"
                              iconSize="16px"
                              title="We'll create a Google Meet room and send Calendar invites to every attendee. No need to paste a link."
                            />
                          </Typography>
                        </Box>

                        {/* Third party meeting link */}
                        <Box display="flex" flexDirection="column" gap={1}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <FormControlLabel
                              value={virtualMeeting}
                              control={<Radio sx={radioStyle} />}
                              label=""
                              className="mr-0"
                            />
                            <Typography sx={radioLabel}>
                              Your own video call (add your own Zoom, Google Meet or Teams link)
                              <MyTooltip
                                gapleft={0.5}
                                iconColor="white"
                                iconSize="16px"
                                title="Paste meeting links from your preferred video conferencing platform here. You and invitees will receive Dosen notifications as normal."
                              />
                            </Typography>
                          </Box>
                          {meetingType === virtualMeeting && (
                            <Box>
                              <TextField
                                id="meetingLinkInput"
                                name="meetingLinkInput"
                                placeholder="Copy paste url here.."
                                value={virtualLink}
                                onChange={handleMeetingLinkChange}
                                fullWidth
                                sx={inputStyle}
                              />
                              {!isValid && (
                                <FormHelperText error sx={{ mt: 0.5 }}>
                                  Please provide a valid url
                                </FormHelperText>
                              )}
                            </Box>
                          )}
                        </Box>

                        {/* In-person event */}
                        <Box display="flex" alignItems="center" gap={1}>
                          <FormControlLabel
                            value={inPersonEvent}
                            control={<Radio sx={radioStyle} />}
                            label=""
                            className="mr-0"
                          />
                          <Typography sx={radioLabel}>
                            In person meeting
                            <MyTooltip
                              gapleft={0.5}
                              iconColor="white"
                              iconSize="16px"
                              title="Log in-person meetings with your members here so that your organization can capture your engagements."
                            />
                          </Typography>
                        </Box>
                      </Stack>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Stack>
            </Box>

            {/* COLUNA DIREITA – CALENDÁRIO + HORÁRIOS */}
            <Box className="CallBookingCalendarCol CallBookingCalendarCol--right">
              <Box className="CallBookingCalendarRightGrid">
                {/* Calendário */}
                <Box className="CallBookingCalendarCard">
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2
                    }}
                  >
                    <IconButton
                      onClick={() => handleMonthChange('prev')}
                      sx={navBtnStyle}
                      size="small"
                      className="nav-btn"
                    >
                      <img src={Left} alt="Previous month" style={{ width: 11, height: 15 }} />
                    </IconButton>

                    <Typography
                      className="calendar-title"
                      sx={{
                        color: '#FDFDFD',
                        fontSize: 16,
                        fontWeight: 700
                      }}
                    >
                      {formatMonthYear(selectedDateTime).monthYear}
                    </Typography>

                    <IconButton
                      onClick={() => handleMonthChange('next')}
                      sx={navBtnStyle}
                      size="small"
                      className="nav-btn"
                    >
                      <img src={Right} alt="Next month" style={{ width: 11, height: 15 }} />
                    </IconButton>
                  </Box>

                  <Box>
                    <DatePicker
                      selected={selectedDateTime}
                      onChange={(date) => handleDateTimeChange(date)}
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      inline
                      minDate={meetingType === inPersonEvent ? undefined : calendarDefaultDate}
                      className="custom-datepicker"
                      calendarClassName="custom-calendar"
                    />
                  </Box>
                </Box>

                {/* Time slots */}
                <Box className="CallBookingTimeSlotsCard">
                  <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Typography
                      className="calendar-title"
                      sx={{
                        color: '#FDFDFD',
                        fontSize: 16,
                        fontWeight: 700
                      }}
                    >
                      {formatMonthYear(selectedDateTime).dayDate}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#FDFDFD',
                        fontSize: 14
                      }}
                    >
                      Your timezone
                    </Typography>
                  </Box>

                  <Box className="time-slots-container" data-testid="call-booking-timeslots">
                    {getTimeSlots()}
                  </Box>
                </Box>
              </Box>

              {/* Textos finais */}
              <Stack gap={1}>
                <Typography
                  sx={{
                    color: '#B6B6B6',
                    fontSize: 14,
                    fontWeight: 700
                  }}
                >
                  Make sure you have agreed a time before booking a meeting.
                </Typography>
                <Typography
                  sx={{
                    color: '#B6B6B6',
                    fontSize: 14
                  }}
                >
                  Once you click the confirm button your meeting will be scheduled.
                </Typography>
              </Stack>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 0,
          bgcolor: '#0F0F0F',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <Button disabled={loading} onClick={handleCancel} sx={cancelBtn}>
          Cancel
        </Button>
        <Button disabled={loading} onClick={handleConfirm} sx={confirmBtn}>
          {loading ? 'Booking...' : 'Confirm'}
        </Button>
      </DialogActions>
    </Box>
  );
};

const labelStyle = {
  color: '#FDFDFD',
  fontSize: 14,
  fontFamily: 'Inter',
  fontWeight: 500,
  lineHeight: '20px',
  mb: 1
};

const inputStyle = {
  '& .MuiOutlinedInput-root': {
    background: 'rgba(0,0,0,0.70)',
    borderRadius: 1,
    border: '1px solid #868686',
    color: '#FDFDFD',
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& .MuiInputBase-input': {
    fontSize: 14
  },
  '& .MuiSvgIcon-root': {
    color: '#868686'
  }
};

const textareaStyle = {
  '& .MuiOutlinedInput-root': {
    background: 'rgba(0,0,0,0.90)',
    borderRadius: 1,
    border: '1px solid #868686',
    color: '#FDFDFD',
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& .MuiInputBase-input': {
    fontSize: 14
  }
};

const radioStyle = {
  color: '#868686',
  '&.Mui-checked': {
    color: '#FDFDFD'
  }
};

const radioLabel = {
  color: '#FDFDFD',
  fontSize: 12,
  fontFamily: 'Inter',
  fontWeight: 400,
  [MOBILE_SX]: { fontSize: 13 }
};

const navBtnStyle = {
  width: 30,
  height: 30,
  borderRadius: '999px',
  border: '1px solid #FDFDFD',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const cancelBtn = {
  width: 200,
  padding: '10px 14px',
  background: '#1C1C1C',
  borderRadius: 1,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
  color: '#FDFDFD',
  fontSize: 13,
  fontFamily: 'Inter',
  fontWeight: 500,
  textTransform: 'none',
  border: '1px solid #444444',
  '&:hover': {
    background: '#2A2A2A'
  },
  '&.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.2)',
    color: '#565656',
    borderColor: '#2A2A2A'
  }
};

const confirmBtn = {
  width: 200,
  padding: '10px 14px',
  background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
  borderRadius: 1,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
  color: '#FDFDFD',
  fontSize: 13,
  fontFamily: 'Inter',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    background: 'linear-gradient(180deg, #FFA93E 0%, #FF6F3E 100%)'
  },
  '&.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.2)',
    color: '#565656',
    boxShadow: 'inset 0 0 0 1px #2A2A2A'
  }
};

export default CallBookingCalendar;
